import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { UserDtoSchema } from '../contracts';

const GetUsersResponseDtoSchema =
  PagePaginationResponseDtoSchema(UserDtoSchema);

export type GetUsersRequestDto = PagePaginationRequestDto<
  { search?: string },
  'createdAt' | 'lastLogin' | 'fullName'
>;
export type GetUsersResponseDto = z.infer<typeof GetUsersResponseDtoSchema>;

export const getUsers = (
  params: GetUsersRequestDto,
  config?: AxiosRequestConfig<GetUsersRequestDto>
) => {
  return api
    .get('/users', { params, ...config })
    .then(responseContract(GetUsersResponseDtoSchema));
};
